import { Building2, ShieldCheck, Zap } from "lucide-react";
import Seo from "@/components/Seo";
import TravelAgentRegistrationForm from "@/components/TravelAgentRegistrationForm";

export default function TravelAgentRegistrationPage() {
  return (
    <div data-testid="travel-agent-registration-page" className="bg-linen">
      <Seo
        title="Travel Agent Registration — Simba Travel · UK Air Zimbabwe GSA"
        description="UK-based travel agents: register with Simba Travel, the appointed UK General Sales Agent for Air Zimbabwe. Get access to trade fares, ticketing support, and dedicated agency service."
      />

      {/* HERO */}
      <section className="pt-28 md:pt-32 pb-8 md:pb-12 border-b border-ink/10" data-testid="agent-reg-hero">
        <div className="container-edge max-w-4xl">
          <div className="overline text-terracotta mb-4">Travel trade</div>
          <h1 className="editorial-h1 text-ink" data-testid="agent-reg-title">
            Register your agency.
          </h1>
          <p className="mt-5 text-base md:text-lg text-ink/70 max-w-2xl font-light leading-relaxed">
            Join the Simba Travel network to book Air Zimbabwe for your customers. Access
            dedicated trade fares, priority ticketing and a UK-based agency desk open seven
            days a week.
          </p>

          <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
            <Perk icon={Building2} title="Trade access" body="IATA and non-IATA UK agents welcome — fare quotes, seat availability and BSP settlement." />
            <Perk icon={ShieldCheck} title="Dedicated desk" body="Named agency sales manager plus a priority ticketing line for confirmed partners." />
            <Perk icon={Zap} title="Fast onboarding" body="Applications typically reviewed within 72 hours by our UK trade team." />
          </div>
        </div>
      </section>

      {/* FORM */}
      <section className="section-pad bg-sand" data-testid="agent-reg-form-section">
        <div className="container-edge max-w-3xl">
          <div className="border border-ink/10 bg-linen p-6 md:p-10 shadow-[0_20px_60px_-30px_rgba(19,26,34,0.2)]">
            <TravelAgentRegistrationForm />
          </div>
        </div>
      </section>
    </div>
  );
}

function Perk({ icon: Icon, title, body }) {
  return (
    <div className="border border-ink/10 bg-sand p-5">
      <Icon className="w-6 h-6 stroke-1 text-terracotta" aria-hidden="true" />
      <h3 className="font-serif text-lg mt-3 text-ink">{title}</h3>
      <p className="text-sm text-muted2 mt-2 leading-relaxed">{body}</p>
    </div>
  );
}
